import { memo } from 'react';

import ChatIconSVG from '@/assets/message-chat-circle.svg?react';
import { Icon, IconProps } from '@/components/core';

const IChatIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={ChatIconSVG} {...props} />;

export const ChatIcon = memo(IChatIcon) as typeof IChatIcon;
